// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1ubjp","form":"style_form__3Kwd7","container--desktop":"style_container--desktop__197-M"};